
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_h11ix_2b4qt_104",
  "icon-flex-height": "awsui_icon-flex-height_h11ix_2b4qt_110",
  "size-small": "awsui_size-small_h11ix_2b4qt_135",
  "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_2b4qt_139",
  "size-normal": "awsui_size-normal_h11ix_2b4qt_154",
  "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_2b4qt_158",
  "size-medium": "awsui_size-medium_h11ix_2b4qt_173",
  "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_2b4qt_177",
  "size-big": "awsui_size-big_h11ix_2b4qt_192",
  "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_2b4qt_196",
  "size-large": "awsui_size-large_h11ix_2b4qt_211",
  "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_2b4qt_215",
  "variant-normal": "awsui_variant-normal_h11ix_2b4qt_230",
  "variant-disabled": "awsui_variant-disabled_h11ix_2b4qt_233",
  "variant-inverted": "awsui_variant-inverted_h11ix_2b4qt_236",
  "variant-subtle": "awsui_variant-subtle_h11ix_2b4qt_239",
  "variant-warning": "awsui_variant-warning_h11ix_2b4qt_242",
  "variant-error": "awsui_variant-error_h11ix_2b4qt_245",
  "variant-success": "awsui_variant-success_h11ix_2b4qt_248",
  "variant-link": "awsui_variant-link_h11ix_2b4qt_251",
  "name-angle-left-double": "awsui_name-angle-left-double_h11ix_2b4qt_254",
  "name-angle-left": "awsui_name-angle-left_h11ix_2b4qt_254",
  "name-angle-right-double": "awsui_name-angle-right-double_h11ix_2b4qt_256",
  "name-angle-right": "awsui_name-angle-right_h11ix_2b4qt_256",
  "name-arrow-left": "awsui_name-arrow-left_h11ix_2b4qt_258",
  "name-caret-left-filled": "awsui_name-caret-left-filled_h11ix_2b4qt_259",
  "name-caret-right-filled": "awsui_name-caret-right-filled_h11ix_2b4qt_260",
  "name-audio-full": "awsui_name-audio-full_h11ix_2b4qt_261",
  "name-audio-half": "awsui_name-audio-half_h11ix_2b4qt_262",
  "name-audio-off": "awsui_name-audio-off_h11ix_2b4qt_263",
  "name-external": "awsui_name-external_h11ix_2b4qt_264",
  "name-redo": "awsui_name-redo_h11ix_2b4qt_265",
  "name-resize-area": "awsui_name-resize-area_h11ix_2b4qt_266",
  "name-shrink": "awsui_name-shrink_h11ix_2b4qt_267",
  "name-undo": "awsui_name-undo_h11ix_2b4qt_268",
  "name-view-vertical": "awsui_name-view-vertical_h11ix_2b4qt_269",
  "badge": "awsui_badge_h11ix_2b4qt_273"
};
  